/**
 * Dummy method, used to prove the index.js is exporting correctly
 * once bundled, we call this method to confirm the package is working as expected
 * @returns true
 */
export function healthCheck(): true {
  return true
}
